import { UploadTexts } from '../../../language/Texts';
import { GeneralAttributes } from '../../../models/GeneralAttributes';
import { RequestPaths } from '../../../models/RequestPaths';
import { UploadProps } from '../../../models/UploadProps';
import BoxComponent from '../../BoxComponent/BoxComponent';

const ConexoUploadKrohne = ({ manufacturer, setConexoResponse, setLoading, loading, resetSession }: UploadProps) => {
    const url = RequestPaths.saveInConexoPathKrohne

    return (
        <>
            {manufacturer === GeneralAttributes.krohne &&
                <BoxComponent
                    boxTitle={UploadTexts.datamatrixOrIdLink}
                    setConexoResponse={setConexoResponse}
                    inputType='text'
                    placeholder={UploadTexts.inputIdLink}
                    buttonText={UploadTexts.saveInConexo}
                    setLoading={setLoading}
                    loading={loading}
                    requestUrl={url}
                    isManufacturerKrohne={true}
                    resetSession={resetSession}
                />
            }
        </>
    )
}

export default ConexoUploadKrohne